import { useMelioIntl } from '@melio/ar-domain';

import { CreateInvoiceFormFields, SubmitTarget } from '../types';

export const useSuccessMessage = () => {
  const { formatMessage } = useMelioIntl();

  const getSuccessMessage = (target?: SubmitTarget, formData?: CreateInvoiceFormFields) => {
    let successMessage = '';
    switch (target) {
      case 'secondary':
        successMessage = formatMessage('ar.invoiceLifecycle.activities.issueInvoice.toasts.created.success.label');
        break;
      case 'primary':
        if (formData?.shouldSendEmail === 'yes') {
          successMessage = formatMessage('ar.invoiceLifecycle.activities.issueInvoice.toasts.sent.success.label');
        } else {
          successMessage = formatMessage('ar.invoiceLifecycle.activities.issueInvoice.toasts.copy.success.label');
        }
        break;
    }

    return successMessage;
  };

  return getSuccessMessage;
};
